export type TNotificationInput = {
  fromUserId: string;
  toAccountId: string;
  toUserId: string;
  messageText: string;
};

export type TNotification = TNotificationInput & {
  messageId: number;
  deviceIdentifier: string;
  fromUserId: string;
  toAccountId: string;
  toUserId: string;
  messageText: string;
  createdAt: string;
  createdDateTime: string;
  errorMessage?: string;
  isSent: boolean;
};

export type TNotificationDeviceAction = {
  accountId: string;
  userId: string;
  deviceActionType: DeviceActionType;
  dictationId?: number;
};

export enum DeviceActionType {
  UploadLogs,
  UploadDictationData,
  UploadPendingDictations,
  UploadDictationById
}
